<template>
  <div class="mt-4 flex flex-col sm:flex-row sm:flex-wrap sm:space-x-8">
      <template v-for="(item, idx) in items" >
        <div v-if="hasValue(item)" v-bind:key="idx" class="flex items-center text-lg text-gray-500">
          <i :class="`fas m-1 fa-solid ${typeof item.icon !== 'undefined' ? item.icon: 'fa-clipboard-check'}`"></i>
          {{item.value}}
        </div>
      </template>
  </div>
</template>
<script>
export default {
  name: 'info-items-home',
  data() {
    return {
      items: []
    }
  },
  created() {
    this.getInfo(),
    this.interval()
  },
  methods: {
    hasValue(item){
      if (item.value === '' || item.value === undefined){
        return false
      }
      return true
    },
    async getInfo() {
      let config = {
        params: {
          ...this.$store.state.data,
          recordid: this.$route.params.record,
          blueprintid: this.$route.params.blueprint,
          query: this.$route.query
        }
      }
      const response = await this.$http.get(`/flow/custom/sessioninfo`, config)

      this.items = response.data

    },
    interval: function(){
      setInterval(function () {
        this.getInfo()
      }.bind(this), 60000);
    },
  }
}
</script>
